import React, { useState } from "react";
import "./SignUp.css";
import { Link, useNavigate } from "react-router-dom";

const SignUp = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState({
    name: '',
    email: '',
    password: '',
    confirm_password: ''
  });

  const handleOnChange = (e) => {
    setUserDetails({
      ...userDetails,
      [e.target.name]: e.target.value
    });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePassword = (password) => {
    return password.length >= 6;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!userDetails.name || !userDetails.email || !userDetails.password || !userDetails.confirm_password) {
      setError('Please fill in all the required fields');
      return;
    }

    if (!validateEmail(userDetails.email)) {
      setError('Please enter a valid email address');
      return;
    }

    if (!validatePassword(userDetails.password)) {
      setError('Password must be at least 6 characters long');
      return;
    }

    if (userDetails.password !== userDetails.confirm_password) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      // Simulate API request (Replace with your actual API request)
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Store user data in localStorage (in real app, do this after successful login)
      localStorage.setItem('registeredUser', JSON.stringify({
        name: userDetails.name,
        email: userDetails.email
      }));

      // Show popup notification
      setShowPopup(true);

      // After a brief delay, redirect to sign-in page
      setTimeout(() => {
        navigate("/sign-in");
      }, 2000);

    } catch (err) {
      setError('Signup failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-up-container">
      {showPopup && (
        <div className="popup-notification success">
          <i className="fas fa-check-circle"></i>
          <p>User registered successfully 😃</p>
        </div>
      )}

      <div className="sign-up-card">
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            Error: {error}
          </div>
        )}

        <h2 className="sign-up-title">
          <i className="fas fa-user-plus"></i>
          Sign up
        </h2>

        <form onSubmit={handleSubmit} className="sign-up-form">
          <div className="input-group">
            <label htmlFor="name">
              <i className="fas fa-user"></i>
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={userDetails.name}
              onChange={handleOnChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="email">
              <i className="fas fa-envelope"></i>
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={userDetails.email}
              onChange={handleOnChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={userDetails.password}
              onChange={handleOnChange}
              placeholder="Create a password"
              required
            />
            <div className="password-hint">
              <i className="fas fa-info-circle"></i>
              Minimum 6 characters
            </div>
          </div>

          <div className="input-group">
            <label htmlFor="confirm_password">
              <i className="fas fa-lock"></i>
              Confirm Password
            </label>
            <input
              type="password"
              id="confirm_password"
              name="confirm_password"
              value={userDetails.confirm_password}
              onChange={handleOnChange}
              placeholder="Confirm your password"
              required
            />
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Signing up...
              </>
            ) : (
              <>
                <i className="fas fa-user-plus"></i>
                Sign up
              </>
            )}
          </button>

          <p className="switch-auth">
            Already have an account?{' '}
            <Link to="/sign-in" className="auth-link">
              Sign in
            </Link>
          </p>

          <p className="terms-text">
            By signing up, you agree to our{' '}
            <a href="/terms">Terms of Service</a> and{' '}
            <a href="/privacy">Privacy Policy</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignUp;